export class ProductCode {
  public static Standard = [
    '201 - 03. Evergreen Standard UK.',
    "200 - 04. Evergreen Digital Int'l",
    '209 - 09. Evergreen Annual UK £12PM',
    '244 - Evergreen Adult Standard',
  ];

  public static Premium = [
    '197 - 01. Evergreen Premium UK.',
    "199 - 02. Evergreen Premium Int'l",
    '206 - 08. Evergreen Annual UK £18PM',
    '210 - 10. Evergreen Premium UK',
    '245 - Evergreen Adult Premium',
  ];
}
